import React from 'react';

const NewsCheckSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 1024 1024"
      strokeWidth="1.5"
      stroke="currentColor"
      transform="scale(-1,1)"
      {...props}
    >
      <path d="M760 518c-141.158 0 -256 -114.842 -256 -256s114.842 -256 256 -256s256 114.842 256 256s-114.842 256 -256 256zM708.825 149.027l-95.0527 94.8477l36.1475 36.25l58.8545 -58.752l46.2256 46.2256l89.3008 89.3008l36.1982 -36.1992l-171.674 -171.674v0.000976562zM848 832h-672c-50.005 0 -90.667 -38.272 -90.667 -85.333v-597.333c0 -47.061 40.661 -85.333 90.667 -85.333h672c50.005 0 90.667 38.272 90.667 85.333v597.333c0 47.061 -40.661 85.333 -90.667 85.333zM848 149.333h-672c-2.432 0 -4.096 0.683 -4.821 0.683c-0.299 0 -0.469 -0.085 -0.512 -0.341l-0.512 595.029c0.299 0.427 2.219 1.963 5.845 1.963h672c3.371 -0.043 5.205 -1.195 5.333 -0.341l0.512 -595.029c-0.299 -0.427 -2.219 -1.963 -5.845 -1.963zM256 661.333h256v-256h-256v256zM520 320h-264v-85.333l255 -1.667l21 66l10 21h-22zM597.333 661.333h170.667v-85.333h-170.667v85.333z"/>
    </svg>
  );
};

export { NewsCheckSVG };